// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"92":"lijnen","522":"hints","570":"memory","954":"vragen"}[chunkId] + "." + {"92":"8c1786b6","522":"4bcd8e2a","570":"33384992","954":"5605784b"}[chunkId] + ".js";
};